export function getBase64(file: File): Promise<string | ArrayBuffer | null> {
  return new Promise<string | ArrayBuffer | null>(resolve => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
  });
}
